// extracted by mini-css-extract-plugin
export default {"Background":"background_Background__zNfia","nav":"background_nav__NeuqX"};